<template>
  <v-card  :style="{ padding: '10px', height: 'fit-content', maxHeight: '100%' }">
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>
    <SearchFilter
      :search="search"
      :rangeDateDialog="rangeDateDialog"
      :dateRangeText="dateRangeText"
      :isResetData="isResetData"
      :search-active-user.sync="searchActiveUser"
      @search="updateSearch" 
      @showType="showType"
      :check-range-date="checkRangeDate"
      :get-data="getData"
    />

    <v-data-table
      :headers="headers"
      fixed-header
      :items="allData"
      :options.sync="options"
      :server-items-length="totalData"
      :loading="loading"
      loading-text="Loading... Please wait"
      :item-class="rowClass"
      class="d-print-table"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 25, 50],
        showFirstLastPage: true,
      }"
      item-key="id"
      sort-by="id"
      :sort-desc="true"
      :style="{ padding: '10px', height: 'fit-content', maxHeight: '100%' }"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-spacer />
          <template>
            <v-btn
              color="warning"
              class="mb-2"
              @click="refeshTable"
              :loading="loading"
              :disabled="loading"
              :style="{ 'margin-right': '10px' }"
              ><v-icon>mdi-restart</v-icon></v-btn
            >
          </template>
        </v-toolbar>
      </template>
      <template v-slot:item="{ item, index }">
        <tr
          :key="index"
          :style="{ cursor: 'pointer', backgroundColor: index % 2 === 0 ? '#EEEEEE' : '#FFF', }"
          :class="selectedRow === index ? 'indigo lighten-4' : ''"
          @click="selectRow(index)"
        >
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ (options.page - 1) * options.itemsPerPage + index + 1 }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.file_name }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell py-2">
            <div class="d-flex flex-column" :style="{ padding: '8px 0' }">
              <v-chip
                :color="item.status === 'Complete' ? 'green' : item.status === 'On Progress' ? 'orange' : 'grey'"
                dark
                small
                block
                class="text-center font-weight-bold d-flex justify-center align-center"
              >
                {{ item.status }}
              </v-chip>
            </div>

            <div class="mt-2" :style="{ fontSize: '0.85rem', lineHeight: '1.4' }">
              <p style="margin: 4px 0;">
                Total Data: {{ item.total_data }}
              </p>
              <p style="margin: 4px 0; color: green;">
                Sukses: {{ item.total_success }}
              </p>
              <p style="margin: 4px 0; color: red;">
                Gagal: {{ item.total_failed }}
              </p>
            </div>
          </td>

          <td class="d-block d-sm-table-cell d-print-table-cell text-center">
            {{ item.created_by_name }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.created_at }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell text-center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon 
                  small 
                  class="mr-2" 
                  v-bind="attrs" 
                  v-on="on"
                @click="downloadResult(item)"
                >mdi-download
                </v-icon>
              </template>
              <span> Download </span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import {date} from '../../../lib/helpers';
import { headers, search } from "./attributes";

export default {
  components: {
    SearchFilter: () => import('./SearchFilter.vue'),
  },
  data: () => ({
    options: {},
    headers,
    search,
    remark: '',
    defaultItem: {},
    selectedRow: null,
    selectedData: [],
    rangeDateDialog: false,
    dateRangeText: '',
    isResetData: true,
    downloadingId: null,
    searchActiveUser: '',

  }),
  mounted() {
    this.getData();
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },

    },
    'search.created_at': {
      handler(newVal) {
        if (newVal.length === 1) {
          this.search.created_at.push(newVal[0]); 
        } else if (newVal.length === 2) {
          this.getData(); 
        }
        if (this.search.created_at.length === 2) {
          this.dateMenu = false; 
        }
      },
      deep: true,
    },
  },
  computed: {
    allData() {
      return this.$store.state.generateQrStatis.dataHistory;
    },
    loading() {
      return this.$store.state.generateQrStatis.loading;
    },
    totalData() {
      return this.$store.state.generateQrStatis.totalData;
    },
    flashError() {
      return this.$store.state.generateQrStatis.flashError;
    },
    flashErrorMessage() {
      return this.$store.state.generateQrStatis.flashErrorMessage;
    },
    onDownloadResult() {
      return this.$store.state.generateQrStatis.onDownloadResult;
    },
  },
  methods: {
    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },
    updateSearch(newSearch) {
      this.search.file_name = newSearch.file_name || ''; 
      this.search.status = newSearch.status || ''; 
      this.search.created_by = newSearch.created_by || ''; 
      this.search.created_at = newSearch.created_at || [];
      this.options.page = 1;
      this.getData(); 
    },
    showType(newSearch) {
      this.clearSelected();
      this.search.file_name = newSearch.file_name; 
      this.search.status = newSearch.status || '';
      this.search.created_by = newSearch.created_by || ''; 
      this.search.created_at = newSearch.created_at || [];
      this.options.page = 1;
      this.getData(); 
    },
    downloadResult(item) {
      this.downloadingId = item.id;
      this.$store
        .dispatch('generateQrStatis/downloadResult', {
          date,
          id: item.id,
        })
        .then(() => {
          this.downloadingId = null; 
        })
        .catch(() => {
          this.downloadingId = null; 
        });
    },
    checkRangeDate() {
      if (this.search.trx_datetime.length === 1) {
        this.search.trx_datetime.push(this.search.trx_datetime[0]);
      }
    },

    getData() {
    
      this.$store.commit('generateQrStatis/setFlashErrorMessage', '');
      const { page, itemsPerPage, } = this.options;

      this.$store
        .dispatch('generateQrStatis/getHistory', {
          date,
          page,
          itemsPerPage,
          search: this.search,
        })
        .then(() => {
          if (this.totalPage < page) {
            this.options.page = this.totalPage === 0 ? 1 : this.totalPage;
          }
        });
    
    },

    clearSelected() {
      this.selectedData = [];
    },
    selectRow(index) {
      this.selectedRow = index === this.selectedRow ? null : index;
    },
    refeshTable() {
      this.getData();
    },
  },
};
</script>
